import React from "react";

import { useQueryString } from "app/context";
import { select } from "app/utils";

import FilterAccordian from "components/common/FilterAccordian";
import FilterTag from "components/common/FilterTag";
import ListItem from "components/filters/ListItem";

const QueryStringSwitchClear = ({ label, queryKey }) => {
  const { queryString, onClearQueryStringKey } = useQueryString();

  return (
    <ListItem
      label={label}
      onClick={() => onClearQueryStringKey(queryKey)}
      active={!queryString[queryKey]}
    />
  );
};

const QueryStringSwitchItem = ({ label, value, queryKey }) => {
  const { queryString, onUpdateQueryString } = useQueryString();

  return (
    <ListItem
      label={label}
      onClick={() => onUpdateQueryString(
        current => ({ ...current, [queryKey]: value })
      )}
      active={queryString[queryKey] === value}
    />
  );
};

const QueryStringSwitch = ({ clearLabel, initialOpen, options, queryKey, title }) => (
  <FilterAccordian initialOpen={initialOpen} title={title}>
    <ul>
      <QueryStringSwitchClear label={clearLabel} queryKey={queryKey} />
      {Object.keys(options).map(key => (
        <QueryStringSwitchItem
          key={key}
          label={options[key]}
          value={key}
          queryKey={queryKey}
        />
      ))}
    </ul>
  </FilterAccordian>
);

export const QueryStringSwitchState = ({ options, queryKey }) => {
  const { queryString, onClearQueryStringKey } = useQueryString();

  if (!queryString[queryKey]) {
    return null;
  }

  return (
    <FilterTag
      label={select(queryString[queryKey], options)}
      onRemove={() => onClearQueryStringKey(queryKey)}
    />
  );
};

export default QueryStringSwitch;
